var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#191919"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.43206 11.873C8.93031 10.3488 11.263 9.34403 12.4302 8.85856C15.7627 7.47245 16.4552 7.23167 16.9065 7.22372C17.0058 7.22197 17.2278 7.24657 17.3715 7.36323C17.4929 7.46174 17.5263 7.59481 17.5423 7.68821C17.5583 7.7816 17.5782 7.99436 17.5624 8.16061C17.3818 10.0581 16.6004 14.6628 16.2029 16.788C16.0346 17.6872 15.7034 17.9888 15.3828 18.0183C14.6859 18.0824 14.1567 17.5577 13.4818 17.1153C12.4256 16.423 11.829 15.992 10.8038 15.3164C9.61901 14.5357 10.3871 14.1066 11.0623 13.4053C11.239 13.2217 14.3093 10.429 14.3688 10.1756C14.3762 10.144 14.3831 10.0258 14.3129 9.96348C14.2428 9.90111 14.1392 9.92244 14.0645 9.9394C13.9586 9.96344 12.2713 11.0786 9.00281 13.285C8.5239 13.6138 8.09012 13.7741 7.70146 13.7657C7.273 13.7564 6.44881 13.5234 5.83611 13.3242C5.08461 13.08 4.48733 12.9508 4.53934 12.5359C4.56643 12.3198 4.864 12.0989 5.43206 11.873Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegramIcon.7626a40bbf625ce980d60e79fa04f5e1.svg";
export { ForwardRef as ReactComponent };